const initialState = {
  data: new Set(),
  assetNamesByWalletAccount: {},
}

export default initialState
